import { CreditCard, QrCode, Receipt } from 'lucide-react'
import type { PaymentMethod, PublicProduct } from '@/types/checkout'

/** One icon per payment method, shared by the product card and its details. */
export const PAYMENT_METHOD_ICONS: Record<PaymentMethod, typeof QrCode> = { PIX: QrCode, CREDIT_CARD: CreditCard, BOLETO: Receipt }

/** The image a product shows as its 3:1 cover, whichever field holds it. */
export const productCover = (product: PublicProduct) =>
  product.imageUrl || product.bannerUrl || product.featuredImageUrl || null
